import React from "react"
import ArchiveTime from "./outline/ArchiveTime"
import Code from "./outline/Code"
import Play from "./outline/Play"
import ArrowDown from "./outline/ArrowDown"
import CreditCard from "./outline/CreditCard"
import Play2 from "./outline/Play2"
import ArrowLeft from "./outline/ArrowLeft"
import Dashboard from "./outline/Dashboard"
import QuestionCircle from "./outline/QuestionCircle"
import ArrowRight from "./outline/ArrowRight"
import Discount from "./outline/Discount"
import RefreshCron from "./outline/RefreshCron"
import ArrowUp from "./outline/ArrowUp"
import DownloadAlt from "./outline/DownloadAlt"
import Refresh from "./outline/Refresh"
import Bell from "./outline/Bell"
import Download from "./outline/Download"
import ServerInstall from "./outline/ServerInstall"
import Blog from "./outline/Blog"
import FileLock from "./outline/FileLock"
import SettingsFilter from "./outline/SettingsFilter"
import Briefcase from "./outline/Briefcase"
import FirewallConnect from "./outline/FirewallConnect"
import ShareSquare from "./outline/ShareSquare"
import Broom from "./outline/Broom"
import GlobeCertified from "./outline/GlobeCertified"
import Statistics from "./outline/Statistics"
import BrowserConfig from "./outline/BrowserConfig"
import GraduationHat from "./outline/GraduationHat"
import Support2 from "./outline/Support2"
import Browser from "./outline/Browser"
import Graph from "./outline/Graph"
import Support from "./outline/Support"
import CalendarSchedule from "./outline/CalendarSchedule"
import Invoice from "./outline/Invoice"
import Tasks from "./outline/Tasks"
import Calendar from "./outline/Calendar"
import Knowledge from "./outline/Knowledge"
import ToText from "./outline/ToText"
import Chat from "./outline/Chat"
import Leaflet from "./outline/Leaflet"
import UserAccount from "./outline/UserAccount"
import CheckCircle from "./outline/CheckCircle"
import Logout from "./outline/Logout"
import UserCard from "./outline/UserCard"
import Check from "./outline/Check"
import Menu from "./outline/Menu"
import UserGroup from "./outline/UserGroup"
import Chip from "./outline/Chip"
import MonitorChart from "./outline/MonitorChart"
import UserSettings from "./outline/UserSettings"
import Close from "./outline/Close"
import Office from "./outline/Office"
import WebSearch from "./outline/WebSearch"

import DuoBell from "./duo/BellDuo"
import DuoLeaflet from "./duo/LeafletDuo"
import DuoBlog from "./duo/BlogDuo"
import DuoLogout from "./duo/LogoutDuo"
import DuoBriefcase from "./duo/BriefcaseDuo"
import DuoMonitorChart from "./duo/MonitorChartDuo"
import DuoBroom from "./duo/BroomDuo"
import DuoOffice from "./duo/OfficeDuo"
import DuoCalendar from "./duo/CalendarDuo"
import DuoPlay from "./duo/PlayDuo"
import DuoCalendarSchedule from "./duo/CalendarScheduleDuo"
import DuoQuestionCircle from "./duo/QuestionCircleDuo"
import DuoQuestionCircleRed from "./duo/QuestionCircleDuoRed"
import DuoChat from "./duo/ChatDuo"
import DuoRefreshCron from "./duo/RefreshCronDuo"
import DuoCheckCircle from "./duo/CheckCircleDuo"
import DuoServerInstall from "./duo/ServerInstallDuo"
import DuoChip from "./duo/ChipDuo"
import DuoSettingsFilter from "./duo/SettingsFilterDuo"
import DuoCreditCard from "./duo/CreditCardDuo"
import DuoShieldCheck from "./duo/ShieldCheckDuo"
import DuoDashboard from "./duo/DashboardDuo"
import DuoSupport2 from "./duo/Support2Duo"
import DuoDiscount from "./duo/DiscountDuo"
import DuoSupport from "./duo/SupportDuo"
import DuoDownloadAlt from "./duo/DownloadAltDuo"
import DuoTasks from "./duo/TasksDuo"
import DuoFirewallConnect from "./duo/FirewallConnectDuo"
import DuoUserAccount from "./duo/UserAccountDuo"
import DuoGlobeCertified from "./duo/GlobeCertifiedDuo"
import DuoUserCard from "./duo/UserCardDuo"
import DuoGraduationHat from "./duo/GraduationHatDuo"
import DuoUserGroup from "./duo/UserGroupDuo"
import DuoGraph from "./duo/GraphDuo"
import DuoUserSettings from "./duo/UserSettingsDuo"
import DuoInvoice from "./duo/InvoiceDuo"
import DuoWebSearch from "./duo/WebSearchDuo"
import DuoKnowledge from "./duo/KnowledgeDuo"
import DuoGovernmentBuilding from "./duo/GovernmentBuildingDuo"
import SocialFacebook from "./social/Facebook"
import SocialLinkedin from "./social/Linkedin"
import SocialTwitter from "./social/Twitter"
import SocialYoutube from "./social/Youtube"
import SocialGoogle from "./social/Google"
import SocialMicrosoft from "./social/Microsoft"
import SocialVimeo from "./social/Vimeo"

export const Icons = {
	ArchiveTime,
	Code,
	Play,
	ArrowDown,
	CreditCard,
	Play2,
	ArrowLeft,
	Dashboard,
	QuestionCircle,
	ArrowRight,
	Discount,
	RefreshCron,
	ArrowUp,
	DownloadAlt,
	Refresh,
	Bell,
	Download,
	ServerInstall,
	Blog,
	FileLock,
	SettingsFilter,
	Briefcase,
	FirewallConnect,
	ShareSquare,
	Broom,
	GlobeCertified,
	Statistics,
	BrowserConfig,
	GraduationHat,
	Support2,
	Browser,
	Graph,
	Support,
	CalendarSchedule,
	Invoice,
	Tasks,
	Calendar,
	Knowledge,
	ToText,
	Chat,
	Leaflet,
	UserAccount,
	CheckCircle,
	Logout,
	UserCard,
	Check,
	Menu,
	UserGroup,
	Chip,
	MonitorChart,
	UserSettings,
	Close,
	Office,
	WebSearch,
	DuoBell,
	DuoLeaflet,
	DuoBlog,
	DuoLogout,
	DuoBriefcase,
	DuoMonitorChart,
	DuoBroom,
	DuoOffice,
	DuoCalendar,
	DuoPlay,
	DuoCalendarSchedule,
	DuoQuestionCircle,
	DuoQuestionCircleRed,
	DuoChat,
	DuoRefreshCron,
	DuoCheckCircle,
	DuoServerInstall,
	DuoChip,
	DuoSettingsFilter,
	DuoCreditCard,
	DuoShieldCheck,
	DuoDashboard,
	DuoSupport2,
	DuoDiscount,
	DuoSupport,
	DuoDownloadAlt,
	DuoTasks,
	DuoFirewallConnect,
	DuoUserAccount,
	DuoGlobeCertified,
	DuoUserCard,
	DuoGraduationHat,
	DuoUserGroup,
	DuoGraph,
	DuoUserSettings,
	DuoInvoice,
	DuoWebSearch,
	DuoKnowledge,
	DuoGovernmentBuilding,
	SocialFacebook,
	SocialLinkedin,
	SocialTwitter,
	SocialYoutube,
	SocialGoogle,
	SocialMicrosoft,
	SocialVimeo,
}
export const IconNames = [
	"ArchiveTime",
	"Code",
	"Play",
	"ArrowDown",
	"CreditCard",
	"Play2",
	"ArrowLeft",
	"Dashboard",
	"QuestionCircle",
	"ArrowRight",
	"Discount",
	"RefreshCron",
	"ArrowUp",
	"DownloadAlt",
	"Refresh",
	"Bell",
	"Download",
	"ServerInstall",
	"Blog",
	"FileLock",
	"SettingsFilter",
	"Briefcase",
	"FirewallConnect",
	"ShareSquare",
	"Broom",
	"GlobeCertified",
	"Statistics",
	"BrowserConfig",
	"GraduationHat",
	"Support2",
	"Browser",
	"Graph",
	"Support",
	"CalendarSchedule",
	"Invoice",
	"Tasks",
	"Calendar",
	"Knowledge",
	"ToText",
	"Chat",
	"Leaflet",
	"UserAccount",
	"CheckCircle",
	"Logout",
	"UserCard",
	"Check",
	"Menu",
	"UserGroup",
	"Chip",
	"MonitorChart",
	"UserSettings",
	"Close",
	"Office",
	"WebSearch",
	"DuoBell",
	"DuoLeaflet",
	"DuoBlog",
	"DuoLogout",
	"DuoBriefcase",
	"DuoMonitorChart",
	"DuoBroom",
	"DuoOffice",
	"DuoCalendar",
	"DuoPlay",
	"DuoCalendarSchedule",
	"DuoQuestionCircle",
	"DuoQuestionCircleRed",
	"DuoChat",
	"DuoRefreshCron",
	"DuoCheckCircle",
	"DuoServerInstall",
	"DuoChip",
	"DuoSettingsFilter",
	"DuoCreditCard",
	"DuoShieldCheck",
	"DuoDashboard",
	"DuoSupport2",
	"DuoDiscount",
	"DuoSupport",
	"DuoDownloadAlt",
	"DuoTasks",
	"DuoFirewallConnect",
	"DuoUserAccount",
	"DuoGlobeCertified",
	"DuoUserCard",
	"DuoGraduationHat",
	"DuoUserGroup",
	"DuoGraph",
	"DuoUserSettings",
	"DuoInvoice",
	"DuoWebSearch",
	"DuoKnowledge",
	"DuoGovernmentBuilding",
	"SocialFacebook",
	"SocialLinkedin",
	"SocialTwitter",
	"SocialYoutube",
	"SocialGoogle",
	"SocialMicrosoft",
	"SocialVimeo",
]

function Icon({ iconName, ...props }) {
	switch (iconName) {
		case "ArchiveTime":
			return <ArchiveTime className={props.className} />
		case "ArrowDown":
			return <ArrowDown className={props.className} />
		case "ArrowLeft":
			return <ArrowLeft className={props.className} />
		case "ArrowRight":
			return <ArrowRight className={props.className} />
		case "ArrowUp":
			return <ArrowUp className={props.className} />
		case "Bell":
			return <Bell className={props.className} />
		case "Blog":
			return <Blog className={props.className} />
		case "Briefcase":
			return <Briefcase className={props.className} />
		case "Broom":
			return <Broom className={props.className} />
		case "BrowserConfig":
			return <BrowserConfig className={props.className} />
		case "Browser":
			return <Browser className={props.className} />
		case "CalendarSchedule":
			return <CalendarSchedule className={props.className} />
		case "Calendar":
			return <Calendar className={props.className} />
		case "Chat":
			return <Chat className={props.className} />
		case "CheckCircle":
			return <CheckCircle className={props.className} />
		case "Check":
			return <Check className={props.className} />
		case "Chip":
			return <Chip className={props.className} />
		case "Close":
			return <Close className={props.className} />
		case "Code":
			return <Code className={props.className} />
		case "CreditCard":
			return <CreditCard className={props.className} />
		case "Dashboard":
			return <Dashboard className={props.className} />
		case "Discount":
			return <Discount className={props.className} />
		case "DownloadAlt":
			return <DownloadAlt className={props.className} />
		case "Download":
			return <Download className={props.className} />
		case "FileLock":
			return <FileLock className={props.className} />
		case "FirewallConnect":
			return <FirewallConnect className={props.className} />
		case "GlobeCertified":
			return <GlobeCertified className={props.className} />
		case "GraduationHat":
			return <GraduationHat className={props.className} />
		case "Graph":
			return <Graph className={props.className} />
		case "Invoice":
			return <Invoice className={props.className} />
		case "Knowledge":
			return <Knowledge className={props.className} />
		case "Leaflet":
			return <Leaflet className={props.className} />
		case "Logout":
			return <Logout className={props.className} />
		case "Menu":
			return <Menu className={props.className} />
		case "MonitorChart":
			return <MonitorChart className={props.className} />
		case "Office":
			return <Office className={props.className} />
		case "Play":
			return <Play className={props.className} />
		case "Play2":
			return <Play2 className={props.className} />
		case "QuestionCircle":
			return <QuestionCircle className={props.className} />
		case "RefreshCron":
			return <RefreshCron className={props.className} />
		case "Refresh":
			return <Refresh className={props.className} />
		case "ServerInstall":
			return <ServerInstall className={props.className} />
		case "SettingsFilter":
			return <SettingsFilter className={props.className} />
		case "ShareSquare":
			return <ShareSquare className={props.className} />
		case "Statistics":
			return <Statistics className={props.className} />
		case "Support2":
			return <Support2 className={props.className} />
		case "Support":
			return <Support className={props.className} />
		case "Tasks":
			return <Tasks className={props.className} />
		case "ToText":
			return <ToText className={props.className} />
		case "UserAccount":
			return <UserAccount className={props.className} />
		case "UserCard":
			return <UserCard className={props.className} />
		case "UserGroup":
			return <UserGroup className={props.className} />
		case "UserSettings":
			return <UserSettings className={props.className} />
		case "WebSearch":
			return <WebSearch className={props.className} />
		case "DuoBell":
			return <DuoBell className={props.className} />
		case "DuoLeaflet":
			return <DuoLeaflet className={props.className} />
		case "DuoBlog":
			return <DuoBlog className={props.className} />
		case "DuoLogout":
			return <DuoLogout className={props.className} />
		case "DuoBriefcase":
			return <DuoBriefcase className={props.className} />
		case "DuoMonitorChart":
			return <DuoMonitorChart className={props.className} />
		case "DuoBroom":
			return <DuoBroom className={props.className} />
		case "DuoOffice":
			return <DuoOffice className={props.className} />
		case "DuoCalendar":
			return <DuoCalendar className={props.className} />
		case "DuoPlay":
			return <DuoPlay className={props.className} />
		case "DuoGovernmentBuilding":
			return <DuoGovernmentBuilding className={props.className} />
		case "DuoCalendarSchedule":
			return <DuoCalendarSchedule className={props.className} />
		case "DuoQuestionCircle":
			return <DuoQuestionCircle className={props.className} />
		case "DuoQuestionCircleRed":
			return <DuoQuestionCircleRed className={props.className} />
		case "DuoChat":
			return <DuoChat className={props.className} />
		case "DuoRefreshCron":
			return <DuoRefreshCron className={props.className} />
		case "DuoCheckCircle":
			return <DuoCheckCircle className={props.className} />
		case "DuoServerInstall":
			return <DuoServerInstall className={props.className} />
		case "DuoChip":
			return <DuoChip className={props.className} />
		case "DuoSettingsFilter":
			return <DuoSettingsFilter className={props.className} />
		case "DuoCreditCard":
			return <DuoCreditCard className={props.className} />
		case "DuoShieldCheck":
			return <DuoShieldCheck className={props.className} />
		case "DuoDashboard":
			return <DuoDashboard className={props.className} />
		case "DuoSupport2":
			return <DuoSupport2 className={props.className} />
		case "DuoDiscount":
			return <DuoDiscount className={props.className} />
		case "DuoSupport":
			return <DuoSupport className={props.className} />
		case "DuoDownloadAlt":
			return <DuoDownloadAlt className={props.className} />
		case "DuoTasks":
			return <DuoTasks className={props.className} />
		case "DuoFirewallConnect":
			return <DuoFirewallConnect className={props.className} />
		case "DuoUserAccount":
			return <DuoUserAccount className={props.className} />
		case "DuoGlobeCertified":
			return <DuoGlobeCertified className={props.className} />
		case "DuoUserCard":
			return <DuoUserCard className={props.className} />
		case "DuoGraduationHat":
			return <DuoGraduationHat className={props.className} />
		case "DuoUserGroup":
			return <DuoUserGroup className={props.className} />
		case "DuoGraph":
			return <DuoGraph className={props.className} />
		case "DuoUserSettings":
			return <DuoUserSettings className={props.className} />
		case "DuoInvoice":
			return <DuoInvoice className={props.className} />
		case "DuoWebSearch":
			return <DuoWebSearch className={props.className} />
		case "DuoKnowledge":
			return <DuoKnowledge className={props.className} />
		case "SocialFacebook":
			return <SocialFacebook className={props.className} />
		case "SocialLinkedin":
			return <SocialLinkedin className={props.className} />
		case "SocialTwitter":
			return <SocialTwitter className={props.className} />
		case "SocialYoutube":
			return <SocialYoutube className={props.className} />
		case "SocialGoogle":
			return <SocialGoogle className={props.className} />
		case "SocialMicrosoft":
			return <SocialMicrosoft className={props.className} />
		case "SocialVimeo":
			return <SocialVimeo className={props.className} />

		default:
			return <ArrowDown className={props.className} />
	}
}

export default Icon
